var map = {
	"./Armature.png": 3329,
	"./Explosive.png": 687,
	"./Jammer.png": 7460,
	"./Laser.png": 6383,
	"./Lidar.png": 4660,
	"./Microwave.png": 5805,
	"./Net.png": 6051,
	"./Projectile.png": 7765,
	"./Radar.png": 9914,
	"./Sprayer.png": 836,
	"./Telescope.png": 3498,
	"./ThermalTargeting.png": 4950,
	"./Unknown.png": 392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;